<template>
    <footer class="footer-area mt-50">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <div class="company-info">
                        <img src="/assets/images/logo.png" alt="logo" />
                        <p>
                            101 E 129th St, East Chicago,
                            <br />IN 46312, US
                        </p>
                        <p>Phone: 001-1234-88888</p>
                        <p>Email: info.deercreative@gmail.com</p>
                    </div>
                    <div class="copyright">
                        <p>
                            Copyright 2019 ©
                            <a href="#">HakDuck</a>. All rights reserved.
                        </p>
                    </div>
                    <div class="payment-gateways">
                        <img src="assets/images/footer/p1.png" alt />
                        <img src="assets/images/footer/p2.png" alt />
                        <img src="assets/images/footer/p3.png" alt />
                        <img src="assets/images/footer/p4.png" alt />
                        <img src="assets/images/footer/p5.png" alt />
                        <img src="assets/images/footer/p6.png" alt />
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="fooer-widget">
                        <h4>Find It Fast</h4>
                        <div class="footer-menu">
                            <ul>
                                <li>
                                    <a href="#">Laptop &amp; Computers</a>
                                </li>
                                <li>
                                    <a href="#">Smart Phone &amp; Tablets</a>
                                </li>
                                <li>
                                    <a href="#">TV &amp; Audio</a>
                                </li>
                                <li>
                                    <a href="#">Cameras &amp; Photography</a>
                                </li>
                                <li>
                                    <a href="#">Gadgets</a>
                                </li>
                                <li>
                                    <a href="#">Car Electronic &amp; GP5</a>
                                </li>
                                <li>
                                    <a href="#">Accesories</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-3 mt-sm-45">
                    <div class="fooer-widget">
                        <h4>Information</h4>
                        <div class="footer-menu">
                            <ul>
                                <li>
                                    <a href="#">Find a Store</a>
                                </li>
                                <li>
                                    <a href="#">About Us</a>
                                </li>
                                <li>
                                    <a href="#">Contact Us</a>
                                </li>
                                <li>
                                    <a href="#">Delivery information</a>
                                </li>
                                <li>
                                    <a href="#">Privacy Policy</a>
                                </li>
                                <li>
                                    <a href="#">Terms &amp; Conditions</a>
                                </li>
                                <li>
                                    <a href="#">Gift Cards</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-3 mt-sm-45">
                    <div class="fooer-widget">
                        <h4>Customer Care</h4>
                        <div class="footer-menu">
                            <ul>
                                <li>
                                    <a href="#">My Account</a>
                                </li>
                                <li>
                                    <a href="#">Order History</a>
                                </li>
                                <li>
                                    <a href="#">Wish List</a>
                                </li>
                                <li>
                                    <a href="#">Customer Service</a>
                                </li>
                                <li>
                                    <a href="#">Returns / Exchange</a>
                                </li>
                                <li>
                                    <a href="#">FAQs</a>
                                </li>
                                <li>
                                    <a href="#">Product Support</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 mt-sm-45">
                    <div class="footer-widget">
                        <div class="subscribe-form">
                            <h3>
                                Sign Up to
                                <strong>Newsletter</strong>
                            </h3>
                            <p>Subscribe our newsletter gor get notification about information discount.</p>
                            <input type="text" placeholder="Your email address" />
                            <button>Subscribe</button>
                        </div>
                        <div class="social-icons style-2">
                            <strong>GET IN TOUCH !</strong>
                            <a href="#">
                                <i class="fab fa-facebook"></i>
                            </a>
                            <a href="#">
                                <i class="fab fa-twitter"></i>
                            </a>
                            <a href="#">
                                <i class="fab fa-instagram"></i>
                            </a>
                            <a href="#">
                                <i class="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>


<script>
    export default {
        name: "FooTer2",
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    .footer-area {
        background-color: #f0f2f9;
        padding: 60px 0 50px 0;

        .company-info {
            padding-bottom: 17px;
        }
        .copyright {
            border-top: 1px solid #e3e4e8;
            padding-top: 25px;
        }
        .company-info p {
            margin: 0 0 5px 0;
        }
        .company-info img {
            margin-bottom: 30px;
            height: 40px;
            background: linear-gradient(70deg, #f00, #000);
        }
        .copyright p {
            margin-bottom: 10px;
        }
        .payment-gateways img {
            display: inline-block;
            margin-right: 14px;
        }
        .fooer-widget h4 {
            margin-bottom: 22px;
        }
        .footer-menu ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        .footer-menu ul li {
            display: block;
        }
        .footer-menu ul li a {
            color: #4c4c4c;
            display: inline-block;
            margin-bottom: 8px;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            // font-weight: var(--bs-body-font-weight);
            color: #191919;
        }
        h4 {
            line-height: 30px;
        }
        .subscribe-form h3 {
            font-weight: 300;
            color: #252525;
        }
        .subscribe-form p {
            margin-bottom: 20px;
        }
        .social-icons.style-2 {
            margin-top: 35px;
        }
        .social-icons.style-2 strong {
            color: #191919;
            text-transform: uppercase;
            margin-right: 20px;
        }
        .social-icons.style-2 strong {
            font-weight: 500;
            letter-spacing: normal;
            text-transform: normal;
        }
        .social-icons.style-2 a {
            color: #191919;
            border: 1px solid #d7d7d7;
            border-radius: 20px;
            width: 37px;
            height: 37px;
            line-height: 35px;
            text-align: center;
            margin-right: 5px;
        }
        .social-icons a {
            color: #191919;
            display: inline-block;
            margin-right: 25px;
            line-height: 40px;
        }
        .subscribe-form input {
            background-color: #dbdde3;
            border: 0;
            height: 40px;
            padding-left: 15px;
            border-radius: 20px 0px 0px 20px;
            float: left;
            width: 65%;
        }
        .subscribe-form button {
            background-color: #e23e1d;
            font-weight: 500;
            height: 40px;
            text-transform: uppercase;
            color: #ffffff;
            border: 0;
            border-radius: 0px 20px 20px 0px;
            width: 35%;
            cursor: pointer;
            transition: 0.3s;
        }
    }
</style>
